import message from 'antd/lib/message';
import { CreateBucketParam } from 'src/services/FlexApiService';

/**
 * 获取图片base64
 * @param file 文件流
 * @returns base64 string
 */
export const getBase64 = async (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * 获取图片信息
 * @param file 图片文件
 * @returns 图片 width height
 */
export const getImgInfo = async (
  file: File
): Promise<{
  width: number;
  height: number;
}> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result as string;
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height,
        });
        img.remove();
      };
      img.onerror = (error) => reject(error);
    };
    reader.onerror = (error) => reject(error);
  });
};

/**
 * 校验图片是否符合要求
 * @param file 图片文件
 * @param maxWidth 最大
 * @param maxHeight 最小
 * @returns 是否存在图片校验错误
 */
export const imgCheckError = async (file: File, maxWidth: number, maxHeight: number): Promise<boolean> => {
  try {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.warning('请上传JPG或PNG格式的图片');
      return true;
    }

    const imgInfo = await getImgInfo(file);
    if (imgInfo.width > maxWidth || imgInfo.height > maxHeight) {
      message.warning('图片建议尺寸 宽800px，高800px');
      return true;
    }
    return false;
  } catch (error) {
    console.error('上传出现错误，请重新上传');

    return true;
  }
};

/**
 * 新建图片名称——当前时间毫秒 + 文件类型
 * @param type 文件 File 的 type 类型
 * @returns 名称
 */
export const createImgName = (type: string): string => {
  let name = `${new Date().getTime()}`;
  if (type === 'image/jpeg') {
    name += '.jpeg';
  } else {
    name += '.png';
  }
  return name;
};

/** 药品上传图片获取bucket 类型枚举 */
export enum EnumBucketType {
  cpmImg = 'mc_cpm_img',
  tcmImg = 'mc_tcm_img',
}

/** 药品上传图片获取bucket 介绍内容 */
export enum EnumBucketIntro {
  cpmIntro = 'macrocura cpm sku pictures',
  tcmIntro = 'macrocura tcm sku pictures',
}

/** 中成药上传图片请求bucket默认参数 */
export const CpmBucketParam: CreateBucketParam = {
  bucket_type: EnumBucketType.cpmImg,
  intro: { name: EnumBucketIntro.cpmIntro },
};

/** 中药上传图片请求bucket默认参数 */
export const tcmBucketParam: CreateBucketParam = {
  bucket_type: EnumBucketType.tcmImg,
  intro: { name: EnumBucketIntro.tcmIntro },
};



// WEBPACK FOOTER //
// ./src/utils/upload.ts